"use client";

import { type CountryCode } from "libphonenumber-js";
import { createContext, useMemo, type ReactNode } from "react";

import { type CurrencyExchangeProps } from "@trip/utils";

export const CurrencyContext = createContext<{
  currencies: CurrencyExchangeProps[];
  currency: CurrencyExchangeProps;
  requestCountryCode: CountryCode;
}>({
  requestCountryCode: "US",
  currencies: [],
  currency: {
    code: "usd",
    exchangeRate: undefined,
    locales: ["en-US", "en"],
    symbol: "$",
  },
});

export function CurrencyProvider({
  currency,
  currencies,
  children,
  requestCountryCode,
}: {
  children: ReactNode;
  currencies: CurrencyExchangeProps[];
  currency: CurrencyExchangeProps;
  requestCountryCode: CountryCode;
}) {
  const value = useMemo(() => {
    return { currencies, currency, requestCountryCode };
  }, [currencies, currency, requestCountryCode]);
  return <CurrencyContext value={value}>{children}</CurrencyContext>;
}
